import React from 'react';
import { IconProps } from '../types/types';

const JST: React.FC<IconProps> = (props) => (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20" role="img" {...props}><circle cx="10" cy="10" r="10" fill="#A42E26" transform="rotate(90 10 10)"/><path fill="#fff" d="M11.343 5.997a1.382 1.382 0 1 1-2.765 0 1.382 1.382 0 0 1 2.765 0Z"/><path fill="#fff" d="M6.03 4.622a3.97 3.97 0 0 0 7.94 0h1.908a5.878 5.878 0 0 1-11.756 0H6.03Zm-1.77 8.755v-1.909h11.4v1.909H4.26Zm5.7 3.649a1.382 1.382 0 1 0 0-2.765 1.382 1.382 0 0 0 0 2.765Z"/></svg>
);

export default JST;
